import { render } from "./TrainingTargetRole.vue?vue&type=template&id=6c5dbb55&scoped=true&ts=true"
import script from "./TrainingTargetRole.vue?vue&type=script&lang=ts"
export * from "./TrainingTargetRole.vue?vue&type=script&lang=ts"

import "./TrainingTargetRole.vue?vue&type=style&index=0&id=6c5dbb55&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5dbb55"]])

export default __exports__